<div [ngClass]="filter.inputClass" class="search-filter-fields"  *ngIf="section.open">
    <input type="text" [(ngModel)]="filter.value" [ngbTypeahead]="search" class="form-control font-relative-width"
    (ngModelChange)="inputChangeEmitter.emit()">
</div>